import * as z from "zod/v4";

export const deleteShipbobIntegration = {
  name: "deleteShipbobIntegration" as const,
  input: z.object({ integrationId: z.string() }),
  output: z.object({}),
};
